import apiClient from './api';

/**
 * Servicio para gestionar las relaciones entre Perfiles y Pruebas (Raven y DISC)
 */
export const perfilPruebaService = {
  /**
   * Listar todas las relaciones perfil-prueba
   */
  getAll: async () => {
    const response = await apiClient.get('/perfil-pruebas');
    return response.data;
  },

  /**
   * Obtener relación por ID
   * @param {number} id - ID de la relación
   */
  getById: async (id) => {
    const response = await apiClient.get(`/perfil-pruebas/${id}`);
    return response.data;
  },

  /**
   * Obtener todas las pruebas (Raven y DISC) asociadas a un perfil
   * @param {number} perfilId - ID del perfil
   */
  getPruebasByPerfil: async (perfilId) => {
    const response = await apiClient.get(`/perfil-pruebas/perfil/${perfilId}`);
    return response.data;
  },

  /**
   * Crear una nueva asociación perfil-prueba (genérico)
   * @param {Object} data - { perfilId, examenRavenId?, testDiscId?, ipvExamenId?, porcentajePonderacion? }
   */
  create: async (data) => {
    const response = await apiClient.post('/perfil-pruebas', data);
    return response.data;
  },

  /**
   * Crear una nueva asociación perfil-prueba - determina el tipo automáticamente
   * @param {Object} data - { perfilId, examenId }
   */
  createPerfilPrueba: async (data) => {
    // Usamos el método create genérico pasando examenRavenId
    const response = await apiClient.post('/perfil-pruebas', {
      perfilId: data.perfilId,
      examenRavenId: data.examenId,
      porcentajePonderacion: 0
    });
    return response.data;
  },

  /**
   * Obtener todos los perfiles asociados a un examen Raven
   * @param {number} examenId - ID del examen Raven
   */
  getPerfilesByExamenRaven: async (examenId) => {
    const response = await apiClient.get(`/perfil-pruebas/examen-raven/${examenId}`);
    return response.data;
  },

  /**
   * Obtener todos los perfiles asociados a un DiscExamen
   * @param {number} discExamenId - ID del DiscExamen
   */
  getPerfilesByDiscExamen: async (discExamenId) => {
    const response = await apiClient.get(`/perfil-pruebas/disc-examen/${discExamenId}`);
    return response.data;
  },

  /**
   * Asociar un examen Raven a un perfil
   * @param {number} perfilId - ID del perfil
   * @param {number} examenId - ID del examen Raven
   */
  asociarExamenRaven: async (perfilId, examenId) => {
    const response = await apiClient.post('/perfil-pruebas/asociar-examen-raven', null, {
      params: { perfilId, examenId }
    });
    return response.data;
  },

  /**
   * Asociar un Test DISC a un perfil (usando testDiscId del maestro)
   * @param {number} perfilId - ID del perfil
   * @param {number} testDiscId - ID del TestDisc maestro
   */
  asociarTestDisc: async (perfilId, testDiscId) => {
    const response = await apiClient.post('/perfil-pruebas/asociar-test-disc', null, {
      params: { perfilId, testDiscId }
    });
    return response.data;
  },

  /**
   * Asociar un DiscExamen a un perfil (método directo)
   * @param {number} perfilId - ID del perfil
   * @param {number} discExamenId - ID del DiscExamen
   */
  asociarDiscExamen: async (perfilId, discExamenId) => {
    const response = await apiClient.post('/perfil-pruebas/asociar-disc-examen', null, {
      params: { perfilId, discExamenId }
    });
    return response.data;
  },

  /**
   * Asociar un IpvExamen a un perfil (método directo)
   * @param {number} perfilId - ID del perfil
   * @param {number} ipvExamenId - ID del IpvExamen
   */
  asociarIpvExamen: async (perfilId, ipvExamenId) => {
    // Intentar primero con endpoint específico
    try {
      const response = await apiClient.post('/perfil-pruebas/asociar-ipv-examen', null, {
        params: { perfilId, ipvExamenId }
      });
      return response.data;
    } catch (error) {
      console.log('⚠️ Endpoint específico falló, usando método genérico...');
      // Si falla, usar el método genérico create
      const response = await apiClient.post('/perfil-pruebas', {
        perfilId,
        ipvExamenId,
        examenRavenId: null,
        testDiscId: null,
        porcentajePonderacion: 0
      });
      return response.data;
    }
  },

  /**
   * Eliminar una asociación perfil-prueba
   * @param {number} id - ID de la relación a eliminar
   */
  delete: async (id) => {
    const response = await apiClient.delete(`/perfil-pruebas/${id}`);
    return response.data;
  }
};

export default perfilPruebaService;
